import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Quote } from '../model/quote';
import { QuoteSummary } from '../model/quote-summary';
import { Adjustment } from '../model/adjustment';
import { AdminOptionCategory } from '../model/admin-option-category';
import { Customer } from '../model/customer';

@Injectable()
export class QuoteInfoService {
  currentPricingView$: BehaviorSubject<number> = new BehaviorSubject(null);
  optionsTotal$: BehaviorSubject<number> = new BehaviorSubject(null);
  quote$: BehaviorSubject<Quote> = new BehaviorSubject(new Quote());
  quoteId$: BehaviorSubject<any> = new BehaviorSubject(null);
  customerId$: BehaviorSubject<number> = new BehaviorSubject(null);
  quoteSummary$: BehaviorSubject<QuoteSummary> = new BehaviorSubject(new QuoteSummary());
  categoryId$: BehaviorSubject<number> = new BehaviorSubject(null);
  adjustment$: BehaviorSubject<Adjustment> = new BehaviorSubject(new Adjustment());
  navCategories$: BehaviorSubject<Array<AdminOptionCategory>> = new BehaviorSubject([new AdminOptionCategory()]);
  categoryName$: BehaviorSubject<string> = new BehaviorSubject(null);
  modelId$: BehaviorSubject<number> = new BehaviorSubject(null);
  canAccessQuote$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  showSideNavFlyOut$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showUserMenu$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showPricingView$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  customer$: BehaviorSubject<Customer> = new BehaviorSubject(new Customer());
  prospectId$: BehaviorSubject<number> = new BehaviorSubject(null);
  creatingBaseOptions$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/quote-info.service.ts